import { render, staticRenderFns } from "./CartDetail.vue?vue&type=template&id=53892cb6&scoped=true&"
import script from "./CartDetail.vue?vue&type=script&lang=js&"
export * from "./CartDetail.vue?vue&type=script&lang=js&"
import style0 from "./CartDetail.vue?vue&type=style&index=0&id=53892cb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53892cb6",
  null
  
)

export default component.exports